module.exports = __webpack_public_path__ + "img/div6-3.d452eb4f.jpg";